import React from "react";
import { Link } from "react-router-dom";
import { WhatsappLogo, InstagramLogo, FacebookLogo, MapPin, Phone, Clock, Globe } from "@phosphor-icons/react";
import { WHATSAPP_NUMBER } from "../lib/api";

export const Footer = () => {
  return (
    <footer id="contacto" className="relative border-t border-white/10 bg-[#0A0A0A]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="font-display text-3xl">CIUDAD GARAJE</div>
          <p className="text-gray-400 text-sm mt-3 leading-relaxed">
            Es cerveza, es arte. Cervezas importadas y la Boutique de Garaje, con obsesión por la calidad: del producto a tu boca.
          </p>
          <div className="flex gap-3 mt-5">
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 border border-white/15 flex items-center justify-center text-gray-300 hover:text-[#D97736] hover:border-[#D97736] transition-colors"
              data-testid="footer-whatsapp"
            >
              <WhatsappLogo size={18} weight="fill" />
            </a>
            <a
              href="https://instagram.com/ciudad.garaje"
              target="_blank"
              rel="noreferrer"
              className="w-10 h-10 border border-white/15 flex items-center justify-center text-gray-300 hover:text-[#D97736] hover:border-[#D97736] transition-colors"
              data-testid="footer-instagram"
            >
              <InstagramLogo size={18} weight="fill" />
            </a>
            <a
              href="#"
              className="w-10 h-10 border border-white/15 flex items-center justify-center text-gray-300 hover:text-[#D97736] hover:border-[#D97736] transition-colors"
            >
              <FacebookLogo size={18} weight="fill" />
            </a>
          </div>
        </div>

        <div>
          <div className="overline mb-4">Navegación</div>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><Link to="/" className="hover:text-[#D97736] transition-colors">Inicio</Link></li>
            <li><Link to="/catalogo" className="hover:text-[#D97736] transition-colors">Catálogo</Link></li>
            <li><Link to="/carrito" className="hover:text-[#D97736] transition-colors">Carrito</Link></li>
            <li><Link to="/admin" className="hover:text-[#D97736] transition-colors">Administración</Link></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Contacto</div>
          <ul className="space-y-3 text-sm text-gray-300">
            <li className="flex gap-2"><MapPin size={18} className="text-[#D97736] shrink-0" /> Avenida Los Laureles, Garaje, San Pedro, Caracas</li>
            <li className="flex gap-2"><Phone size={18} className="text-[#D97736] shrink-0" /> +58 422 427 2531</li>
            <li className="flex gap-2">
              <Globe size={18} className="text-[#D97736] shrink-0" />
              <a href="https://www.ciudad-garaje.com" target="_blank" rel="noreferrer" className="hover:text-[#D97736] transition-colors" data-testid="footer-website">www.ciudad-garaje.com</a>
            </li>
            <li className="flex gap-2">
              <InstagramLogo size={18} className="text-[#D97736] shrink-0" />
              <a href="https://instagram.com/ciudad.garaje" target="_blank" rel="noreferrer" className="hover:text-[#D97736] transition-colors" data-testid="footer-instagram-handle">@ciudad.garaje</a>
            </li>
            <li className="flex gap-2"><Clock size={18} className="text-[#D97736] shrink-0" /> Lun–Sáb · 12:00 – 23:00</li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Aviso</div>
          <p className="text-gray-500 text-xs leading-relaxed">
            Venta exclusiva para mayores de 18 años. El abuso en el consumo de este producto es nocivo para la salud. Evita el exceso.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-gray-600 text-xs">
        © {new Date().getFullYear()} Ciudad Garaje. Todos los derechos reservados.
      </div>
    </footer>
  );
};
